import { gql, type TypedDocumentNode } from "@apollo/client";

export type EmploymentClassificationOption = {
  id: string;
  name: string;
};

export type EmploymentClassificationsQueryResponse = {
  employmentClassifications: EmploymentClassificationOption[];
};

export type EmploymentClassificationsQueryVariables = {
  programType: "associate" | "member";
};

export const EMPLOYMENT_CLASSIFICATIONS_QUERY: TypedDocumentNode<
  EmploymentClassificationsQueryResponse,
  EmploymentClassificationsQueryVariables
> = gql`
  query EmploymentClassifications($programType: String!) {
    employmentClassifications(programType: $programType) {
      id
      name
    }
  }
`;

export type EmploymentTitleOption = {
  id: string;
  jobTitle: string;
  jobClassification: string;
};

export type EmploymentTitlesQueryResponse = {
  employmentTitles: EmploymentTitleOption[];
};

export type EmploymentTitlesQueryVariables = {
  programType: "associate" | "member";
  jobClassification?: string | null;
};

export const EMPLOYMENT_TITLES_QUERY: TypedDocumentNode<EmploymentTitlesQueryResponse, EmploymentTitlesQueryVariables> =
  gql`
    query EmploymentTitles($programType: String!, $jobClassification: String) {
      employmentTitles(programType: $programType, jobClassification: $jobClassification) {
        id
        jobTitle
        jobClassification
      }
    }
  `;

export type TourCodesQueryResponse = {
  tourCodes: Array<{
    id: string;
    code: string;
    name: string;
    current: boolean;
    facility: {
      id: string;
      name: string;
    };
  }>;
};

export const TOUR_CODES_QUERY: TypedDocumentNode<TourCodesQueryResponse, Record<string, never>> = gql`
  query ApplicationReviewTourCodes {
    tourCodes {
      id
      code
      name
      current
      facility {
        id
        name
      }
    }
  }
`;
